import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordLine',
  props: {
    value: null
  },
  setup(__props: any) {

const props = __props as {
    value: string|number;
};

const view= ref<boolean>(false)
function click(){
    view.value=!view.value
}

return { __sfc: true,props, view, click }
}

})